import { FIELD_DATA } from './fieldData.js';
/**
 * Fields in the internal workbook that the customer dictionary (the version
 * ATTOM has) doesn't list. They're left out of the dictionary page, the permit
 * popup and the sample files (#173).
 */
const NOT_IN_CUSTOMER_DICTIONARY = new Set([
    'estimated_cost',
    'estimated_cost_imputed',
    'is_cost_imputed',
    'cost_basis',
]);
/** The customer data dictionary's Permits fields, in its order (#171). */
export const DICTIONARY_FIELDS = FIELD_DATA.filter((f) => !NOT_IN_CUSTOMER_DICTIONARY.has(f.name));
export const DICTIONARY_GROUPS = [
    ...new Set(DICTIONARY_FIELDS.map((f) => f.group)),
];
//# sourceMappingURL=fields.js.map